import { __awaiter, __generator } from "tslib";
import { findAppDefinitionById } from '@office-start/m365-apps-service';
export var getDialogType = function (_a) {
    var appId = _a.appId;
    return __awaiter(void 0, void 0, void 0, function () {
        var appDefinition;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, findAppDefinitionById(appId)];
                case 1:
                    appDefinition = _b.sent();
                    if ((appDefinition === null || appDefinition === void 0 ? void 0 : appDefinition.acquisitionState) === 'NeedsConsentForUpgrade') {
                        return [2 /*return*/, 'UPGRADE'];
                    }
                    return [2 /*return*/, 'INSTALL'];
            }
        });
    });
};
//# sourceMappingURL=getDialogType.js.map